import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 mt-2" }, [
  /*#__PURE__*/_createElementVNode("i", null, "No comments yet.")
], -1)

import CommentListItem from "@/components/comment/CommentListItem.vue"
import CommentListItemBrief from "@/components/comment/CommentListItemBrief.vue"
import { Comment } from "@/models/comment";
import { useMutation } from "@vue/apollo-composable";
import gql from "graphql-tag";


export default /*#__PURE__*/_defineComponent({
  props: {
    comments: null,
    brief: { type: Boolean }
  },
  setup(__props: any) {



const mutation = gql`
  mutation DeleteComment($uuid: uuid!) {
    delete_comment_by_pk(uuid: $uuid) {
      uuid
    }
  }
`;

const { mutate } = useMutation(mutation);

const deleteComment = (uuid: string) => {
    mutate({ uuid });
};

return (_ctx: any,_cache: any) => {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_DataView = _resolveComponent("DataView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmDialog),
    _createVNode(_component_DataView, {
      value: __props.comments,
      layout: 'list'
    }, {
      list: _withCtx((slotProps) => [
        (__props.brief)
          ? (_openBlock(), _createBlock(CommentListItemBrief, {
              key: 0,
              comment: slotProps.data
            }, null, 8, ["comment"]))
          : (_openBlock(), _createBlock(CommentListItem, {
              key: 1,
              comment: slotProps.data,
              onDeleteClick: _cache[0] || (_cache[0] = ($event: any) => (deleteComment($event)))
            }, null, 8, ["comment"]))
      ]),
      empty: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["value"])
  ], 64))
}
}

})